import { Navigate, useLocation } from 'react-router';
import { UserContextV2 } from '~/app';
import { LoadingSpinner } from '~/components';
import { DefaultRoleRedirect } from './DefaultRoleRedirect';
import { buildRegistrationPath, readRegistrationReturnTo } from './registrationReturnTo';
import { paths } from './routes';

/** Only the role picker can start registration; a URL cannot choose a role. */
export const RegistrationRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isAuthSettling = UserContextV2.useSelector(
    (state) =>
      state.matches('$_AUTHENTICATING') ||
      state.matches('$_FETCHING_USER') ||
      state.matches('$_RESOLVING_USER_INFO')
  );
  const isRegistered = UserContextV2.useSelector((state) => state.matches('$_AUTHENTICATED'));
  const isProviderRegistration = UserContextV2.useSelector((state) =>
    state.matches('$_PROVIDER_REGISTRATION')
  );
  const isEmployerRegistration = UserContextV2.useSelector((state) =>
    state.matches('$_EMPLOYER_REGISTRATION')
  );

  if (isAuthSettling) return <LoadingSpinner />;
  if (isRegistered) return <DefaultRoleRedirect />;

  // Returning to the picker lets the user change an earlier explicit choice.
  if (location.pathname === paths.register.roleSelect) return <>{children}</>;

  const registrationPath = isProviderRegistration
    ? paths.register.provider
    : isEmployerRegistration
      ? paths.register.employer
      : paths.register.roleSelect;

  if (location.pathname !== registrationPath) {
    return (
      <Navigate
        to={buildRegistrationPath(registrationPath, readRegistrationReturnTo(location.search))}
        replace
      />
    );
  }

  return <>{children}</>;
};
